import { defaultRegionInfoProvider } from "./endpoints";
/**
 * @internal
 */
export var ClientSharedValues = {
    apiVersion: "2006-03-01",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: defaultRegionInfoProvider,
    serviceId: "s3",
    signingEscapePath: false,
    useArnRegion: false,
};
//# sourceMappingURL=runtimeConfig.shared.js.map